export const IMAGE_FILE_MAX_SIZE_IN_BYTES = 1100000; // ~1MB (value from the backend validation)
